import './FieldsetSelect.scss';

import { FormEvent, useEffect, useRef, useState } from 'react';

export interface SelectKeyValue {
  key: string;
  value: string;
}

interface FieldsetSelecttProps {
  name?: string;
  label: string;
  id: string;
  validationMessage?: string;
  placeholder?: string;
  focus?: boolean;
  items: SelectKeyValue[];
  dataTestId?: string;
  value?: string | number | readonly string[];

  onChange: (event: FormEvent<HTMLSelectElement>) => void;
  onBlur?: () => void;
}
export const FieldsetSelect = (props: FieldsetSelecttProps) => {
  const {
    id,
    label,
    onChange,
    name,
    onBlur,
    validationMessage,
    placeholder,
    focus,
    items,
    dataTestId,
    value,
  } = props;

  const [fieldsetInvalid, setFieldsetInvalid] = useState(false);
  const selectRef = useRef<HTMLSelectElement>(null);

  useEffect(() => {
    setFieldsetInvalid(validationMessage ? true : false);
  }, [validationMessage]);

  useEffect(() => {
    if (focus && selectRef.current) {
      selectRef.current.focus();
    }
  }, [focus]);

  return (
    <div className="fieldset-select-container">
      <fieldset className={`fieldset ${fieldsetInvalid ? 'invalid' : ''}`}>
        <legend>{label ? <label htmlFor={id}>{label}</label> : <></>}</legend>
        <select
          id={id}
          name={name}
          placeholder={placeholder}
          onChange={onChange}
          ref={selectRef}
          data-testid={dataTestId}
          onBlur={onBlur}
          value={value}
        >
          <option value=""></option>
          {items.map((c) => {
            return (
              <option value={c.key} key={`${c.key}-${c.value}`}>
                {c.value}
              </option>
            );
          })}
        </select>
      </fieldset>
      {validationMessage ? (
        <p className="validation-message">{validationMessage}</p>
      ) : (
        <></>
      )}
    </div>
  );
};
